import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CreateApplicationComponent} from "./application/create/create-application.component";
import {OktaCallbackComponent} from "@okta/okta-angular";
import {OnboardGuardService} from "./core/guards/onboard-guard.service";
import {GroupGuardService} from "./core/guards/group-guard.service";
const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    pathMatch: 'full',
    canActivate: [OnboardGuardService, GroupGuardService]
  },
  {
    path: 'applications',
    loadChildren: () => import('./application/application.module').then(m => m.ApplicationModule),
    canActivate: [OnboardGuardService, GroupGuardService]
  },
  {path: 'applications/create', component: CreateApplicationComponent, canActivate: [OnboardGuardService]},
  {
    path: 'applications/:id',
    loadChildren: () => import('./application/application-detail/application-detail.module').then(m => m.ApplicationDetailModule),
    canActivate: [OnboardGuardService]
  },
  {
    path: 'campaigns',
    loadChildren: () => import('./campaign/campaign.module').then(m => m.CampaignModule)
  },
  {
    path: 'campaigns/:campaignId/promotions',
    loadChildren: () => import('./campaign/campaign.module').then(m => m.CampaignModule),
    canActivate: [OnboardGuardService, GroupGuardService]
  },
  {
    path: 'configuration',
    loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule),
    canActivate: [OnboardGuardService, GroupGuardService]
  },
  {
    path: 'configuration/brand/:brandId',
    loadChildren: () => import('./configuration/brand/brand.module').then(m => m.BrandModule),
    canActivate: [OnboardGuardService, GroupGuardService]
  },
  { path: 'configuration/brand/:brandId/product/:productUid', loadChildren: () => import('./configuration/product/product.module').then(m => m.ProductModule) },
  {path: 'logs', loadChildren: () => import('./logs/logs.module').then(m => m.LogsModule), canActivate: [OnboardGuardService]},
  {path: 'reports', loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule), canActivate: [OnboardGuardService]},
  {path: 'user-profile', loadChildren: () => import('./user-profile/user-profile.module').then(m => m.UserProfileModule)},
  {path: 'login/callback', component: OktaCallbackComponent},
  {
    path: '**', pathMatch: 'full', canActivate: [OnboardGuardService], // GroupGuardService
    children: []
    // redirectTo: 'onboard/dashboard'
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
